import React from 'react';

import checkIcon from '../../../assets/images/shared/icons/check-circle-solid.svg';

const TrustpilotReview = ({
  createdAt,
  displayName,
  isVerified,
  text,
  title,
  starImage,
  id,
}) => {
  const getDuration = seconds => {
    const DURATION_IN_SECONDS = {
      epochs: ['year', 'month', 'day', 'hour', 'minute'],
      year: 31536000,
      month: 2592000,
      day: 86400,
      hour: 3600,
      minute: 60,
    };
    let epoch;
    let interval;
    for (let i = 0; i < DURATION_IN_SECONDS.epochs.length; i++) {
      epoch = DURATION_IN_SECONDS.epochs[i];
      interval = Math.floor(seconds / DURATION_IN_SECONDS[epoch]);
      if (interval >= 1) {
        break;
      }
    }
    return {
      interval,
      epoch,
    };
  };

  const timeSince = date => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const { interval, epoch } = getDuration(seconds);
    const suffix = interval > 1 || interval === 0 ? 's' : '';
    return `${interval} ${epoch}${suffix}`;
  };

  return (
    <div className="review-container" data-testid="trustpilot-review">
      <div className="fl jc-sb m-b-1rem">
        <div className="fl review-star-container ai-c">
          <a
            data-testid="trustpilot-stars-link"
            className="dark-link"
            rel="nofollow noopener noreferrer"
            target="_blank"
            href={`https://uk.trustpilot.com/reviews/${id}`}>
            <img
              className="review-trustpilot-stars"
              alt="stars"
              src={starImage}
            />
          </a>
          {isVerified && (
            <div className="no-margin fl ai-c verified-container">
              <img
                className="review-verified"
                alt="verified order"
                src={checkIcon}
              />
              <p className="no-margin ">Verified Order</p>
              <span className="hover-effect" role="tooltip">
                <p
                  className="verified-content no-margin"
                  data-testid="verified-content">
                  {displayName} was invited to write this review by CEF.{' '}
                  <a
                    rel="nofollow noopener noreferrer"
                    target="_blank"
                    href={`https://uk.trustpilot.com/reviews/${id}`}>
                    Learn more
                  </a>
                </p>
              </span>
            </div>
          )}
        </div>
        <div className="fl ai-c">
          <p className="review-order-date no-margin">
            {timeSince(createdAt)} ago
          </p>
        </div>
      </div>
      <p className="lf">
        <a
          className="dark-link"
          rel="nofollow noopener noreferrer"
          target="_blank"
          href={`https://uk.trustpilot.com/reviews/${id}`}>
          <strong>{title}</strong>
        </a>
      </p>
      <p className="review-text">{text}</p>
      <p className="review-display-name">{displayName}</p>
    </div>
  );
};

export default TrustpilotReview;
